<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
    <Loading></Loading>
  </div>
</template>

<script>
import Loading from '@/components/base/loading'
export default {
  components: {
    Loading
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    /* 页面刷新 */
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: "PingFang SC-Regular, PingFang SC";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
}
</style>
